import store from './../../store/index'

export default function (to, from) {
  return store.commit('shop/setUseRootContainer', true)
}



// WEBPACK FOOTER //
// ./client/router/guards/afterEach.js